export type TemplateStatus = "draft" | "active" | "inactive";

export type TemplateUsage = {
  id: number;
  name: string;
  status: TemplateStatus;
  is_translation: boolean;
  via_snippet: string | null;
};

export type SnippetUsage = {
  id: number;
  name: string;
};

export type ResourceUsages = {
  templates: TemplateUsage[];
  snippets: SnippetUsage[];
  translations: SnippetUsage[];
};

export type ResourceReplacementRequest = {
  replace_with: string;
  dry_run: boolean;
};

export type ResourceReplacementResult = {
  replaced_references: number;
  updated_templates: TemplateUsage[];
  updated_snippets: SnippetUsage[];
  updated_active_templates: TemplateUsage[];
  dry_run: boolean;
};

export type TemplateSnippetReference = {
  key: string;
  snippet_id: number;
  name: string;
};

export type TemplateAssetReference = {
  url: string;
  asset_id: number | null;
  name: string | null;
  via_snippet: string | null;
};


export const usageCount = (usages?: ResourceUsages): number =>
  (usages?.templates.length ?? 0) + (usages?.snippets.length ?? 0) + (usages?.translations?.length ?? 0);

export const activeTemplates = (usages?: ResourceUsages): TemplateUsage[] =>
  (usages?.templates ?? []).filter((template) => template.status === "active");

export const plural = (count: number, noun: string) => `${count} ${noun}${count === 1 ? "" : "s"}`;

export const usageSummary = (usages?: ResourceUsages): string => {
  const templates = usages?.templates.length ?? 0;
  const snippets = usages?.snippets.length ?? 0;
  const live = activeTemplates(usages).length;
  const parts: string[] = [];
  if (templates) parts.push(`${plural(templates, "template")}${live ? ` (${live} live)` : ""}`);
  if (snippets) parts.push(plural(snippets, "snippet"));
  const translations = usages?.translations?.length ?? 0;
  if (translations) parts.push(plural(translations, "translation"));
  return parts.join(" and ");
};
